import { useEffect } from 'react';

const textMap = {
  en: {
    'Abrir menú': 'Open menu',
    'Cerrar menú': 'Close menu',
    'Más acciones': 'More actions',
    'Cerrar Sesión': 'Logout',
    'Conectado como': 'Connected as',
    'Panel de Finanzas': 'Finance Panel',
    'Panel de Administración': 'Administration Panel',
    'Panel de Admin': 'Admin Panel',
    'Gestiona usuarios y monitorea el sistema': 'Manage users and monitor the system',
    'Centro de Control': 'Control Center',
    'Estado del Sistema': 'System Status',
    'Base de datos': 'Database',
    'Disco usado': 'Disk used',
    'Libre': 'Free',
    'Intentos fallidos 24h': 'Failed attempts 24h',
    'Intentos de Login Fallidos': 'Failed Login Attempts',
    'Origen de los intentos fallidos registrados en las últimas 24 horas.': 'Source of failed attempts recorded in the last 24 hours.',
    'IP': 'IP',
    'País': 'Country',
    'Intentos': 'Attempts',
    'Emails': 'Emails',
    'Motivos': 'Reasons',
    'Último intento': 'Last attempt',
    'Últimos intentos fallidos': 'Latest failed attempts',
    'Motivo': 'Reason',
    'Borrar todos': 'Delete all',
    'Borrar intento': 'Delete attempt',
    'Intento fallido eliminado': 'Failed attempt deleted',
    'Intentos fallidos eliminados': 'Failed attempts deleted',
    'No fue posible borrar el intento fallido': 'The failed attempt could not be deleted',
    'No fue posible borrar los intentos fallidos': 'The failed attempts could not be deleted',
    'No hay intentos fallidos registrados': 'No failed attempts recorded',
    'Bloquear IP': 'Block IP',
    'Desbloquear IP': 'Unblock IP',
    'IP bloqueada': 'IP blocked',
    'IP desbloqueada': 'IP unblocked',
    'No fue posible actualizar la IP': 'The IP could not be updated',
    'Último backup': 'Last backup',
    'No registrado': 'Not recorded',
    'Seguridad': 'Security',
    'Modo mantenimiento': 'Maintenance mode',
    'Marca el sistema para intervención administrativa': 'Marks the system for administrative maintenance',
    'Registro:': 'Registration:',
    'abierto': 'open',
    'cerrado': 'closed',
    'Invitación:': 'Invitation:',
    'Reset usuario:': 'User reset:',
    'permitido': 'allowed',
    'bloqueado': 'blocked',
    'Backups': 'Backups',
    'Crear backup manual': 'Create manual backup',
    'Archivo': 'File',
    'Tamaño': 'Size',
    'Creado': 'Created',
    'No hay backups registrados': 'No backups recorded',
    'Backup creado': 'Backup created',
    'No fue posible crear el backup': 'The backup could not be created',
    'Modo mantenimiento activado': 'Maintenance mode enabled',
    'Modo mantenimiento desactivado': 'Maintenance mode disabled',
    'No fue posible actualizar mantenimiento': 'Maintenance could not be updated',
    'Auditoría': 'Audit',
    'Auditoría Administrativa': 'Admin Audit',
    'Acciones sensibles realizadas por administradores o por reset financiero del usuario.': 'Sensitive actions performed by administrators or user financial resets.',
    'Administrador': 'Administrator',
    'Objetivo': 'Target',
    'No hay auditoría registrada': 'No audit records',
    'Importaciones': 'Imports',
    'Monitor de Importaciones': 'Import Monitor',
    'Resumen de importaciones confirmadas desde extractos bancarios o facturas de tarjeta.': 'Summary of confirmed imports from bank statements or card invoices.',
    'Banco': 'Bank',
    'Total': 'Total',
    'No hay importaciones registradas': 'No imports recorded',
    'Datos': 'Data',
    'Cuentas:': 'Accounts:',
    'Metas:': 'Goals:',
    'Deudas:': 'Debts:',
    'Rec.:': 'Rec.:',
    'Notif.:': 'Notif.:',
    'Total Usuarios': 'Total Users',
    'Usuarios Activos': 'Active Users',
    'Transacciones': 'Transactions',
    'Transacción': 'Transaction',
    'Logins (24h)': 'Logins (24h)',
    'Datos en Base de Datos': 'Database Data',
    'Usuarios': 'Users',
    'Invitaciones': 'Invitations',
    'Últimos Accesos': 'Recent Access',
    'Registro de Accesos': 'Access Log',
    'Usuarios Registrados': 'Registered Users',
    'Nombre': 'Name',
    'Rol': 'Role',
    'Estado': 'Status',
    'Último Acceso': 'Last Access',
    'Fecha/Hora': 'Date/Time',
    'Acciones': 'Actions',
    'Limpiar registros': 'Clear logs',
    'Eliminar registro': 'Delete log',
    'Registro de acceso eliminado': 'Access log deleted',
    'Registros de acceso eliminados': 'Access logs deleted',
    'No fue posible eliminar el registro': 'The log could not be deleted',
    'No fue posible limpiar los registros': 'The logs could not be cleared',
    '¿Eliminar este registro de acceso?': 'Delete this access log?',
    '¿Eliminar todos los registros de acceso? Esta acción no se puede deshacer.': 'Delete all access logs? This action cannot be undone.',
    'Sin IP': 'No IP',
    'No hay registros de acceso': 'No access logs',
    'login': 'login',
    'admin_user_update': 'admin user update',
    'admin_user_financial_reset': 'admin financial reset',
    'self_financial_reset': 'self financial reset',
    'Activo': 'Active',
    'Inactivo': 'Inactive',
    'Nunca': 'Never',
    'Cancelar': 'Cancel',
    'Guardar': 'Save',
    'Guardando…': 'Saving...',
    'Guardar cambios': 'Save changes',
    'Actualizar': 'Update',
    'Crear': 'Create',
    'Eliminar': 'Delete',
    'Editar': 'Edit',
    'Nuevo': 'New',
    'Nueva': 'New',
    'Nueva Transacción': 'New Transaction',
    'Editar Transacción': 'Edit Transaction',
    'Modifica los datos de la transacción': 'Edit transaction details',
    'Tipo': 'Type',
    'Categoría': 'Category',
    'Categorías': 'Categories',
    'Descripción': 'Description',
    'Cuenta': 'Account',
    'Cuentas': 'Accounts',
    'Fecha': 'Date',
    'Monto': 'Amount',
    'Ingreso': 'Income',
    'Ingresos': 'Income',
    'Gasto': 'Expense',
    'Gastos': 'Expenses',
    'Transferencia': 'Transfer',
    'Transferencias': 'Transfers',
    'Todos': 'All',
    'Todas': 'All',
    'Todos los tipos': 'All types',
    'Todas las etiquetas': 'All tags',
    'Etiqueta': 'Tag',
    'Desde': 'From',
    'Hasta': 'To',
    'Fecha inicial': 'Start date',
    'Fecha final': 'End date',
    'Limpiar fechas': 'Clear dates',
    'Este mes': 'This month',
    'Mes pasado': 'Last month',
    'Últimos 7 días': 'Last 7 days',
    'Total filtrado': 'Filtered total',
    'Historial completo de movimientos': 'Complete movement history',
    'Buscar por categoría o descripción...': 'Search by category or description...',
    'Filtrar por tipo': 'Filter by type',
    'No hay transacciones que mostrar': 'No transactions to show',
    'No hay transacciones registradas': 'No transactions recorded',
    'Añadir la primera': 'Add the first one',
    'Añadir primera transacción': 'Add first transaction',
    'Crear presupuesto mensual': 'Create monthly budget',
    'Balance real hoy': 'Real balance today',
    'Disponible para gastar': 'Available to spend',
    'Ingresos este mes': 'Income this month',
    'Gastos este mes': 'Expenses this month',
    'Transacciones recientes': 'Recent Transactions',
    'Ver todas': 'View all',
    'Ver todas →': 'View all →',
    'acumulado total': 'total accumulated',
    'ingresos − gastos del mes': 'income - expenses this month',
    'según tu presupuesto': 'based on your budget',
    'Top categorías del mes': 'Top categories this month',
    'Aún no hay gastos este mes.': 'No expenses yet this month.',
    'Presupuestos': 'Budgets',
    'Presupuesto': 'Budget',
    'Presupuestos del Mes': 'Monthly Budgets',
    'Definir Presupuesto': 'Set Budget',
    'Define un límite mensual por categoría': 'Set a monthly limit by category',
    'Seleccionar categoría': 'Select category',
    'Nuevo presupuesto': 'New budget',
    'Editar presupuesto': 'Edit budget',
    'Crear presupuesto': 'Create budget',
    'Restante': 'Remaining',
    'Excedido por': 'Exceeded by',
    'Sin presupuestos para': 'No budgets for',
    'Mes:': 'Month:',
    '◄ Anterior': '◄ Previous',
    'Hoy': 'Today',
    'Siguiente ►': 'Next ►',
    'Efectivo': 'Cash',
    'Cuenta Bancaria': 'Bank Account',
    'Cuenta bancaria': 'Bank account',
    'Tarjeta de Crédito': 'Credit Card',
    'Tarjeta de crédito': 'Credit card',
    'Billetera Digital': 'Digital Wallet',
    'Billetera digital': 'Digital wallet',
    'Inversiones': 'Investments',
    '· tarjeta': '· card',
    '· inversiones': '· investments',
    'Efectivo, bancos, tarjetas, billeteras digitales e inversiones': 'Cash, banks, cards, digital wallets, and investments',
    'Aún no tienes cuentas': 'You do not have accounts yet',
    'Crea tu primera cuenta para empezar a vincular transacciones.': 'Create your first account to start linking transactions.',
    'Crear primera cuenta': 'Create first account',
    'Nueva cuenta': 'New account',
    'Editar cuenta': 'Edit account',
    'Crear cuenta': 'Create account',
    'Actualiza los datos de tu cuenta': 'Update your account details',
    'Crea una cuenta para clasificar tus transacciones': 'Create an account to classify your transactions',
    'Saldo actual': 'Current balance',
    'Saldo de la tarjeta': 'Card balance',
    'Pagar tarjeta': 'Pay card',
    'Registra el pago como transferencia hacia': 'Register the payment as a transfer to',
    'Cuenta origen': 'Source account',
    'Selecciona una cuenta': 'Select an account',
    'Monto a pagar': 'Amount to pay',
    'Fecha de pago': 'Payment date',
    'Pago de tarjeta': 'Card payment',
    'Registrar pago': 'Record payment',
    'Registrando...': 'Recording...',
    'No fue posible registrar el pago.': 'The payment could not be recorded.',
    'Selecciona la cuenta desde donde saldrá el pago.': 'Select the account the payment will come from.',
    'Ingresa un valor mayor que cero.': 'Enter an amount greater than zero.',
    'Factura': 'Statement',
    'Próximas cuotas': 'Upcoming installments',
    'Sin cuenta': 'No account',
    'Seleccionar cuenta': 'Select account',
    '+ Crear una cuenta': '+ Create an account',
    '+ Añadir primera cuenta': '+ Add first account',
    'Metas': 'Goals',
    'Metas y deudas': 'Goals and debts',
    'Meta de ahorro': 'Savings goal',
    'Fondo de emergencia': 'Emergency fund',
    'Deudas': 'Debts',
    'Deuda': 'Debt',
    'Aportar': 'Contribute',
    'Pagar': 'Pay',
    'Saldo actual:': 'Current balance:',
    'Saldo pendiente:': 'Outstanding balance:',
    'sin interés': 'no interest',
    'Reportes': 'Reports',
    'Cash flow, categorías, recurrentes y exportación': 'Cash flow, categories, recurring items, and exports',
    'Exportar': 'Export',
    'Formato': 'Format',
    'Recibos': 'Receipts',
    'Importar extracto bancario': 'Import bank statement',
    'Banco / formato': 'Bank / format',
    'Sube un extracto CSV u OFX y escoge el banco o país del archivo': 'Upload a CSV or OFX statement and choose the file bank or country',
    'Formatos: CSV / OFX exportados de Itaú (también funciona genérico)': 'Formats: CSV / OFX exported from the selected bank (generic also works)',
    'En CSV genérico usa columnas parecidas a: Data/Fecha/Date, Descrição/Descripción/Description/Concepto y Valor/Monto/Amount. Valores negativos = gastos, positivos = ingresos.': 'For generic CSV files use columns like: Data/Fecha/Date, Descrição/Descripción/Description/Concepto and Valor/Monto/Amount. Negative values are expenses, positive values are income.',
    'Ninguna': 'None',
    'Configuración': 'Settings',
    'Información de la Cuenta': 'Account Information',
    'Tu información personal': 'Your personal information',
    'Email Verificado': 'Email Verified',
    'Sí': 'Yes',
    'No': 'No',
    'Cambiar Contraseña': 'Change Password',
    'Contraseña Actual': 'Current Password',
    'Nueva Contraseña': 'New Password',
    'Notificaciones': 'Notifications',
    'Recibe avisos por email, Telegram o WhatsApp cuando se acerque la fecha de pago': 'Receive alerts by email, Telegram, or WhatsApp when a payment date is approaching',
    'Notificaciones activadas': 'Notifications enabled',
    'Si las desactivas, no se enviarán avisos automáticos': 'If you turn them off, automatic alerts will not be sent',
    'Canales': 'Channels',
    'Avisar X días antes': 'Notify X days before',
    'Email destino': 'Destination email',
    'Si lo dejas vacío, se usa': 'If left empty, this will use',
    'Configurar Telegram': 'Configure Telegram',
    'Configurar WhatsApp': 'Configure WhatsApp',
    'activo': 'active',
    'expandir': 'expand',
    'Bot Token': 'Bot token',
    'Chat ID': 'Chat ID',
    '¿Cómo obtengo bot token y chat ID?': 'How do I get the bot token and chat ID?',
    'Número de WhatsApp': 'WhatsApp number',
    'Solo dígitos. Brasil:': 'Digits only. Brazil:',
    'WhatsApp usa una conexión central configurada por el administrador del servidor.': 'WhatsApp uses a central connection configured by the server administrator.',
    'Envío automático diario a las': 'Automatic daily sending at',
    'Próxima ejecución:': 'Next run:',
    'Última ejecución:': 'Last run:',
    'Guardar configuración': 'Save settings',
    'Probar email': 'Test email',
    'Probar Telegram': 'Test Telegram',
    'Probar WhatsApp': 'Test WhatsApp',
    'Notificar ahora': 'Notify now',
    'Configura el bot primero': 'Configure the bot first',
    'Enviar prueba': 'Send test',
    'Carga tu número primero': 'Enter your number first',
    'Enviar prueba por WhatsApp': 'Send WhatsApp test',
    'Activa notificaciones primero': 'Enable notifications first',
    'Idioma del sitio': 'Site language',
    'Elige el idioma que quieres usar dentro del sistema': 'Choose the language you want to use inside the system',
    'Idioma actual:': 'Current language:',
    'Moneda preferida': 'Preferred currency',
    'Moneda': 'Currency',
    'Moneda en dashboard': 'Dashboard currency',
    'Idioma': 'Language',
    'Recuperar Contraseña': 'Recover Password',
    'Ingresa tu email para recibir el código de recuperación': 'Enter your email to receive the recovery code',
    'Enviar Código': 'Send Code',
    'Restablecer Contraseña': 'Reset Password',
    'Código de Recuperación': 'Recovery Code',
    'Contraseña': 'Password',
    'Confirmar Contraseña': 'Confirm Password',
    'Notas (opcional)': 'Notes (optional)',
    'Etiquetas (separadas por coma)': 'Tags (comma separated)',
    'Adjuntar recibo (imagen o PDF, ≤ 5 MB)': 'Attach receipt (image or PDF, up to 5 MB)',
    'Leyendo recibo…': 'Reading receipt...',
    'Pre-llenar desde foto del recibo': 'Pre-fill from receipt photo',
    'Selecciona una fecha': 'Select a date',
    'Recurrentes': 'Recurring',
    'Guardar recurrente': 'Save recurring item',
    'Próximos pagos (14 días)': 'Upcoming payments (14 days)',
    'Internet residencial': 'Home internet',
    'Insights inteligentes': 'Smart insights',
    'Aún no hay movimientos este mes': 'No movements yet this month',
    'Importa tu extracto o registra transacciones para comparar con el mes anterior.': 'Import your statement or record transactions to compare with the previous month.',
    'Ingresos vs Gastos por mes': 'Income vs Expenses by month',
    'Gastos por categoría': 'Expenses by category',
    'Patrimonio': 'Net worth',
    'Líquido': 'Liquid',
    'Crear primera meta': 'Create first goal',
    '+ Crear primera meta': '+ Create first goal',
    'Sin deudas registradas': 'No debts recorded',
    'Organiza tus ingresos y gastos en categorías y subcategorías': 'Organize your income and expenses into categories and subcategories',
    'Define cuánto quieres gastar este mes por categoría. Te avisaremos cuando te acerques al límite y cuando lo excedas.': 'Define how much you want to spend this month by category. We will alert you when you approach the limit and when you exceed it.',
    'Crear primer presupuesto': 'Create first budget',
    'No budgets for': 'No budgets for',
    'Impuestos': 'Taxes',
    'Impuestos / Tasas': 'Taxes / Fees',
    'Servicios': 'Services',
    'Educación': 'Education',
    'Vivienda': 'Housing',
    'Otros': 'Other',
    'Entretenimiento': 'Entertainment',
    'Salud': 'Health',
    'Alimentación': 'Food',
    'Supermercado': 'Groceries',
    'Transporte': 'Transportation',
    'Trabajo': 'Work',
    'Sueldo': 'Salary',
    'Bonos / Comisiones': 'Bonuses / Commissions',
    'Pensión / Jubilación': 'Pension / Retirement',
    'Préstamo recibido': 'Loan received',
    'Rendimientos / Inversiones': 'Returns / Investments',
    'Proventos': 'Investment proceeds',
    'vs mes anterior': 'vs previous month',
    'acumulado total': 'total accumulated',
    'de tus gastos': 'of your expenses',
    '¡Presupuesto excedido!': 'Budget exceeded!',
    'Sistema': 'System',
    'Inactiva': 'Inactive',
    'Subcategoría': 'Subcategory',
    'Cargando…': 'Loading...',
    'Cargando presupuestos…': 'Loading budgets...',
    'Cargando recibos…': 'Loading receipts...',
    'Cargando recibo…': 'Loading receipt...',
    'Crear la primera': 'Create the first one',
    'Nueva categoría': 'New category',
    'Nueva subcategoría': 'New subcategory',
    'Solo puedes editar el nombre y color': 'You can only edit the name and color',
    'Define el nombre y tipo de la categoría': 'Define the category name and type',
    'Categoría padre (opcional)': 'Parent category (optional)',
    'Recurrentes activos': 'Active recurring items',
    'Total mensual estimado': 'Estimated monthly total',
    'solo gastos activos': 'active expenses only',
    'Generar este mes': 'Generate this month',
    'Manual': 'Manual',
    'Plantillas rápidas': 'Quick templates',
    'Un clic para precargar el formulario con los datos típicos. Solo te queda poner el monto.': 'One click pre-fills the form with typical data. You only need to enter the amount.',
    'Tus recurrentes': 'Your recurring items',
    'Sin recurrentes': 'No recurring items',
    'Sin recurrentes activos': 'No active recurring items',
    'Alquiler, internet, suscripciones y otras facturas mensuales': 'Rent, internet, subscriptions, and other monthly bills',
    'Alquiler': 'Rent',
    'Alquiler mensual': 'Monthly rent',
    'Teléfono / Plan': 'Phone / Plan',
    'Plan móvil': 'Mobile plan',
    'Seguro': 'Insurance',
    'Seguro mensual': 'Monthly insurance',
    'Luz / Agua / Gas': 'Electricity / Water / Gas',
    'Servicios públicos': 'Utilities',
    'Gimnasio': 'Gym',
    'Mensualidad gym': 'Gym membership',
    'Suscripción': 'Subscription',
    'Otra suscripción': 'Other subscription',
    'Donación': 'Donation',
    'Donación mensual': 'Monthly donation',
    'Coche': 'Car',
    'Cuota / seguro vehículo': 'Payment / vehicle insurance',
    'Todo al día — no había recurrentes pendientes': 'Everything is up to date — there were no pending recurring items',
    'Se generará automáticamente cada mes al pulsar "Generar este mes".': 'It will be generated automatically each month when you press "Generate this month".',
    'Ingresos vs mes anterior': 'Income vs previous month',
    'Gastos vs mes anterior': 'Expenses vs previous month',
    'día': 'day',
    'pago día': 'payment day',
    'Cartão': 'Card',
    'Tarjeta': 'Card',
    'tarjeta': 'card',
    'padre': 'parent',
    'Define un límite mensual por categoría y mira cómo lo estás cumpliendo.': 'Set a monthly limit by category and see how you are tracking.',
    'excedidos / cerca del límite': 'exceeded / near the limit',
    'Cerca del límite': 'Near the limit',
    'Crea categorías de gasto en': 'Create expense categories in',
    'Todas tus categorías ya tienen presupuesto este mes.': 'All your categories already have a budget this month.',
    'Límite mensual': 'Monthly limit',
    'Meta': 'Goal',
    'Aún no tienes metas': 'You do not have goals yet',
    'Nueva meta': 'New goal',
    'Nueva deuda': 'New debt',
    'Registrar primera deuda': 'Register first debt',
    'Registra préstamos, financiamientos o saldos pendientes para hacer seguimiento.': 'Register loans, financing, or outstanding balances to track them.',
    'Crea una meta de ahorro o tu fondo de emergencia': 'Create a savings goal or your emergency fund',
    'Fecha límite (opcional)': 'Deadline (optional)',
    'Crear meta': 'Create goal',
    'Registra una deuda, préstamo o financiamiento': 'Register a debt, loan, or financing',
    '% interés anual': 'Annual interest %',
    'Día de pago': 'Payment day',
    'Crear deuda': 'Create debt',
    'deuda(s)': 'debt(s)',
    'anual': 'annual',
    'Total ahorrado': 'Total saved',
    'Define tu primer objetivo de ahorro o tu fondo de emergencia.': 'Define your first savings goal or your emergency fund.',
    'Deuda total': 'Total debt',
    'No configurado': 'Not configured',
    'Fondo de emergencia': 'Emergency fund',
    'Emergency fund': 'Emergency fund',
    'Distribución': 'Distribution',
    'Top categorías': 'Top categories',
    'Sin gastos en este periodo': 'No expenses in this period',
    'Mayor categoría': 'Largest category',
    'Por categoría': 'By category',
    'Progreso por meta': 'Progress by goal',
    'Aún no tienes metas creadas.': 'You do not have any goals yet.',
    'Exportar todo': 'Export all',
    'Periodo:': 'Period:',
    'Periodo': 'Period',
    'Objetivo total': 'Total target',
    'Progreso global': 'Overall progress',
    'Estimado anual': 'Annual estimate',
    'Mes actual': 'Current month',
    'Mes anterior': 'Previous month',
    'Año actual (YTD)': 'Year to date (YTD)',
    'Últimos 3 meses': 'Last 3 months',
    'Últimos 6 meses': 'Last 6 months',
    'Últimos 12 meses': 'Last 12 months',
    'sin datos': 'no data',
    'Galería de recibos': 'Receipt gallery',
    'Todos los comprobantes adjuntos a tus transacciones': 'All receipts attached to your transactions',
    'Filtros:': 'Filters:',
    'Todas las categorías': 'All categories',
    'Todos los meses': 'All months',
    'Limpiar filtros': 'Clear filters',
    'recibo(s)': 'receipt(s)',
    'Total:': 'Total:',
    'en gastos': 'in expenses',
    'Sin recibos para estos filtros': 'No receipts for these filters',
    'Aún no tienes recibos': 'You do not have receipts yet',
    'Prueba a ajustar los filtros o limpiar la selección.': 'Try adjusting the filters or clearing the selection.',
    'Adjunta recibos a tus transacciones desde el dashboard o el editor de transacciones — aparecerán aquí automáticamente.': 'Attach receipts to your transactions from the dashboard or transaction editor — they will appear here automatically.',
    'Detalle del recibo': 'Receipt detail',
    'No se pudo cargar el recibo.': 'The receipt could not be loaded.',
    'Importación completada': 'Import completed',
    'Categoría por defecto': 'Default category',
    'Procesando…': 'Processing...',
    'Arrastra tu archivo aquí o haz clic': 'Drag your file here or click',
    'Formatos: CSV / OFX exportados por banco o CSV genérico con fecha, descripción y valor': 'Formats: CSV / OFX exported by bank or generic CSV with date, description, and value',
    '¿Dónde consigo el archivo?': 'Where do I get the file?',
    'Accede a tu banca web o app del banco.': 'Access your bank website or mobile app.',
    'Ve a': 'Go to',
    'y elige el periodo.': 'and choose the period.',
    'Descarga el extracto como': 'Download the statement as',
    'u': 'or',
    'Selecciona el banco/formato y sube el archivo aquí. Verás un preview antes de guardar.': 'Select the bank/format and upload the file here. You will see a preview before saving.',
    'Cuenta destino (opcional)': 'Destination account (optional)',
    'Cuenta destino': 'Destination account',
    'Cuenta origen': 'Source account',
    'Cuenta origen (opcional)': 'Source account (optional)',
    'periodo': 'period',
    'Descarga el extracto como': 'Download the statement as',
    'Selecciona el banco/formato y sube el archivo aquí. Verás un preview antes de guardar.': 'Select the bank/format and upload the file here. You will see a preview before saving.',
    'Incluir esta transacción': 'Include this transaction',
    'Selecciona al menos una transacción.': 'Select at least one transaction.',
    'Para importar transferencias selecciona cuenta origen y cuenta destino diferente.': 'To import transfers, select different source and destination accounts.',
    'Error al guardar': 'Error saving',
    'Gestiona tu cuenta y preferencias': 'Manage your account and preferences',
    'Elige la moneda en que se mostrarán todos tus montos': 'Choose the currency used to display all your amounts',
    'Actualiza tu contraseña de acceso': 'Update your access password',
    'Confirmar Nueva Contraseña': 'Confirm New Password',
    'Configuración guardada': 'Settings saved',
    'No se pudo guardar la configuración': 'The settings could not be saved',
    'Las contraseñas no coinciden': 'Passwords do not match',
    'La contraseña debe tener al menos 6 caracteres': 'The password must have at least 6 characters',
    'Contraseña actualizada correctamente': 'Password updated successfully',
    'Error al cambiar la contraseña': 'Error changing password',
    'Se procesaron': 'Processed',
    'pagos próximos': 'upcoming payments',
    'ya configurado, deja vacío para mantener': 'already configured, leave empty to keep',
    'con código de país, sin +': 'with country code, without +',
    'Si el botón "Probar WhatsApp" devuelve un error de "no configurado", avísale al': 'If the "Test WhatsApp" button returns a "not configured" error, notify the',
    'usuario(s)': 'user(s)',
    'aviso(s)': 'alert(s)',
    'Para guardar como transferencia selecciona cuenta origen y cuenta destino.': 'To save as a transfer, select source and destination accounts.',
    'La cuenta origen y la cuenta destino deben ser diferentes.': 'Source and destination accounts must be different.',
    'Para convertir en transferencia selecciona una cuenta origen y una cuenta destino diferente.': 'To convert to a transfer, select a source account and a different destination account.',
    'No se pudo guardar la transacción. Revisa los datos e intenta nuevamente.': 'The transaction could not be saved. Check the data and try again.',
    'Reiniciar datos financieros': 'Reset financial data',
    'Esta acción borra cuentas, transacciones, presupuestos, metas, deudas, recurrentes, recibos y registros financieros del usuario. La cuenta de acceso se conserva.': 'This action deletes the user financial accounts, transactions, budgets, goals, debts, recurring items, receipts, and financial logs. The login account is preserved.',
    'Escribe RESET': 'Type RESET',
    'Reiniciar': 'Reset',
    'Datos financieros reiniciados para': 'Financial data reset for',
    'Transacciones eliminadas:': 'Deleted transactions:',
    'No fue posible reiniciar los datos financieros': 'The financial data could not be reset',
  },
  pt: {
    'Abrir menú': 'Abrir menu',
    'Cerrar menú': 'Fechar menu',
    'Más acciones': 'Mais ações',
    'Cerrar Sesión': 'Sair',
    'Conectado como': 'Conectado como',
    'Panel de Finanzas': 'Painel Financeiro',
    'Panel de Administración': 'Painel de Administração',
    'Panel de Admin': 'Painel Admin',
    'Gestiona usuarios y monitorea el sistema': 'Gerencie usuários e monitore o sistema',
    'Centro de Control': 'Centro de Controle',
    'Estado del Sistema': 'Estado do Sistema',
    'Base de datos': 'Banco de dados',
    'Disco usado': 'Disco usado',
    'Libre': 'Livre',
    'Intentos fallidos 24h': 'Tentativas falhas 24h',
    'Intentos de Login Fallidos': 'Tentativas de Login Falhas',
    'Origen de los intentos fallidos registrados en las últimas 24 horas.': 'Origem das tentativas falhas registradas nas últimas 24 horas.',
    'IP': 'IP',
    'País': 'País',
    'Intentos': 'Tentativas',
    'Emails': 'Emails',
    'Motivos': 'Motivos',
    'Último intento': 'Última tentativa',
    'Últimos intentos fallidos': 'Últimas tentativas falhas',
    'Motivo': 'Motivo',
    'Borrar todos': 'Excluir todos',
    'Borrar intento': 'Excluir tentativa',
    'Intento fallido eliminado': 'Tentativa falha excluída',
    'Intentos fallidos eliminados': 'Tentativas falhas excluídas',
    'No fue posible borrar el intento fallido': 'Não foi possível excluir a tentativa falha',
    'No fue posible borrar los intentos fallidos': 'Não foi possível excluir as tentativas falhas',
    'No hay intentos fallidos registrados': 'Nenhuma tentativa falha registrada',
    'Bloquear IP': 'Bloquear IP',
    'Desbloquear IP': 'Desbloquear IP',
    'IP bloqueada': 'IP bloqueado',
    'IP desbloqueada': 'IP desbloqueado',
    'No fue posible actualizar la IP': 'Não foi possível atualizar o IP',
    'Último backup': 'Último backup',
    'No registrado': 'Não registrado',
    'Seguridad': 'Segurança',
    'Modo mantenimiento': 'Modo manutenção',
    'Marca el sistema para intervención administrativa': 'Marca o sistema para manutenção administrativa',
    'Registro:': 'Registro:',
    'abierto': 'aberto',
    'cerrado': 'fechado',
    'Invitación:': 'Convite:',
    'Reset usuario:': 'Reset usuário:',
    'permitido': 'permitido',
    'bloqueado': 'bloqueado',
    'Backups': 'Backups',
    'Crear backup manual': 'Criar backup manual',
    'Archivo': 'Arquivo',
    'Tamaño': 'Tamanho',
    'Creado': 'Criado',
    'No hay backups registrados': 'Nenhum backup registrado',
    'Backup creado': 'Backup criado',
    'No fue posible crear el backup': 'Não foi possível criar o backup',
    'Modo mantenimiento activado': 'Modo manutenção ativado',
    'Modo mantenimiento desactivado': 'Modo manutenção desativado',
    'No fue posible actualizar mantenimiento': 'Não foi possível atualizar manutenção',
    'Auditoría': 'Auditoria',
    'Auditoría Administrativa': 'Auditoria Administrativa',
    'Acciones sensibles realizadas por administradores o por reset financiero del usuario.': 'Ações sensíveis realizadas por administradores ou pelo reset financeiro do usuário.',
    'Administrador': 'Administrador',
    'Objetivo': 'Alvo',
    'No hay auditoría registrada': 'Nenhuma auditoria registrada',
    'Importaciones': 'Importações',
    'Monitor de Importaciones': 'Monitor de Importações',
    'Resumen de importaciones confirmadas desde extractos bancarios o facturas de tarjeta.': 'Resumo de importações confirmadas de extratos bancários ou faturas de cartão.',
    'Banco': 'Banco',
    'Total': 'Total',
    'No hay importaciones registradas': 'Nenhuma importação registrada',
    'Datos': 'Dados',
    'Cuentas:': 'Contas:',
    'Metas:': 'Metas:',
    'Deudas:': 'Dívidas:',
    'Rec.:': 'Rec.:',
    'Notif.:': 'Notif.:',
    'Total Usuarios': 'Total de Usuários',
    'Usuarios Activos': 'Usuários Ativos',
    'Transacciones': 'Transações',
    'Transacción': 'Transação',
    'Logins (24h)': 'Logins (24h)',
    'Datos en Base de Datos': 'Dados no Banco',
    'Usuarios': 'Usuários',
    'Invitaciones': 'Convites',
    'Últimos Accesos': 'Últimos Acessos',
    'Registro de Accesos': 'Registro de Acessos',
    'Usuarios Registrados': 'Usuários Registrados',
    'Nombre': 'Nome',
    'Rol': 'Função',
    'Estado': 'Status',
    'Último Acceso': 'Último Acesso',
    'Fecha/Hora': 'Data/Hora',
    'Acciones': 'Ações',
    'Limpiar registros': 'Limpar registros',
    'Eliminar registro': 'Excluir registro',
    'Registro de acceso eliminado': 'Registro de acesso excluído',
    'Registros de acceso eliminados': 'Registros de acesso excluídos',
    'No fue posible eliminar el registro': 'Não foi possível excluir o registro',
    'No fue posible limpiar los registros': 'Não foi possível limpar os registros',
    '¿Eliminar este registro de acceso?': 'Excluir este registro de acesso?',
    '¿Eliminar todos los registros de acceso? Esta acción no se puede deshacer.': 'Excluir todos os registros de acesso? Esta ação não pode ser desfeita.',
    'Sin IP': 'Sem IP',
    'No hay registros de acceso': 'Nenhum registro de acesso',
    'login': 'login',
    'admin_user_update': 'atualização de usuário pelo admin',
    'admin_user_financial_reset': 'reset financeiro pelo admin',
    'self_financial_reset': 'reset financeiro próprio',
    'Activo': 'Ativo',
    'Inactivo': 'Inativo',
    'Nunca': 'Nunca',
    'Cancelar': 'Cancelar',
    'Guardar': 'Salvar',
    'Guardando…': 'Salvando...',
    'Guardar cambios': 'Salvar alterações',
    'Actualizar': 'Atualizar',
    'Crear': 'Criar',
    'Eliminar': 'Excluir',
    'Editar': 'Editar',
    'Nuevo': 'Novo',
    'Nueva': 'Nova',
    'Nueva Transacción': 'Nova Transação',
    'Editar Transacción': 'Editar Transação',
    'Modifica los datos de la transacción': 'Modifique os dados da transação',
    'Tipo': 'Tipo',
    'Categoría': 'Categoria',
    'Categorías': 'Categorias',
    'Descripción': 'Descrição',
    'Cuenta': 'Conta',
    'Cuentas': 'Contas',
    'Fecha': 'Data',
    'Monto': 'Valor',
    'Ingreso': 'Receita',
    'Ingresos': 'Receitas',
    'Gasto': 'Despesa',
    'Gastos': 'Despesas',
    'Transferencia': 'Transferência',
    'Transferencias': 'Transferências',
    'Todos': 'Todos',
    'Todas': 'Todas',
    'Todos los tipos': 'Todos os tipos',
    'Todas las etiquetas': 'Todas as etiquetas',
    'Etiqueta': 'Etiqueta',
    'Desde': 'Desde',
    'Hasta': 'Até',
    'Fecha inicial': 'Data inicial',
    'Fecha final': 'Data final',
    'Limpiar fechas': 'Limpar datas',
    'Este mes': 'Este mês',
    'Mes pasado': 'Mês passado',
    'Últimos 7 días': 'Últimos 7 dias',
    'Total filtrado': 'Total filtrado',
    'Historial completo de movimientos': 'Histórico completo de movimentações',
    'Buscar por categoría o descripción...': 'Buscar por categoria ou descrição...',
    'Filtrar por tipo': 'Filtrar por tipo',
    'No hay transacciones que mostrar': 'Nenhuma transação para mostrar',
    'No hay transacciones registradas': 'Nenhuma transação registrada',
    'Añadir la primera': 'Adicionar a primeira',
    'Añadir primera transacción': 'Adicionar primeira transação',
    'Crear presupuesto mensual': 'Criar orçamento mensal',
    'Balance real hoy': 'Saldo real hoje',
    'Disponible para gastar': 'Disponível para gastar',
    'Ingresos este mes': 'Receitas este mês',
    'Gastos este mes': 'Despesas este mês',
    'Transacciones recientes': 'Transações recentes',
    'Ver todas': 'Ver todas',
    'Ver todas →': 'Ver todas →',
    'acumulado total': 'acumulado total',
    'ingresos − gastos del mes': 'receitas - despesas do mês',
    'según tu presupuesto': 'conforme seu orçamento',
    'Top categorías del mes': 'Principais categorias do mês',
    'Aún no hay gastos este mes.': 'Ainda não há despesas este mês.',
    'Presupuestos': 'Orçamentos',
    'Presupuesto': 'Orçamento',
    'Presupuestos del Mes': 'Orçamentos do mês',
    'Definir Presupuesto': 'Definir Orçamento',
    'Define un límite mensual por categoría': 'Defina um limite mensal por categoria',
    'Seleccionar categoría': 'Selecionar categoria',
    'Nuevo presupuesto': 'Novo orçamento',
    'Editar presupuesto': 'Editar orçamento',
    'Crear presupuesto': 'Criar orçamento',
    'Restante': 'Restante',
    'Excedido por': 'Excedido em',
    'Sin presupuestos para': 'Sem orçamentos para',
    'Mes:': 'Mês:',
    '◄ Anterior': '◄ Anterior',
    'Hoy': 'Hoje',
    'Siguiente ►': 'Próximo ►',
    'Efectivo': 'Dinheiro',
    'Cuenta Bancaria': 'Conta Bancária',
    'Cuenta bancaria': 'Conta bancária',
    'Tarjeta de Crédito': 'Cartão de Crédito',
    'Tarjeta de crédito': 'Cartão de crédito',
    'Billetera Digital': 'Carteira Digital',
    'Billetera digital': 'Carteira digital',
    'Inversiones': 'Investimentos',
    '· tarjeta': '· cartão',
    '· inversiones': '· investimentos',
    'Efectivo, bancos, tarjetas, billeteras digitales e inversiones': 'Dinheiro, bancos, cartões, carteiras digitais e investimentos',
    'Aún no tienes cuentas': 'Você ainda não tem contas',
    'Crea tu primera cuenta para empezar a vincular transacciones.': 'Crie sua primeira conta para começar a vincular transações.',
    'Crear primera cuenta': 'Criar primeira conta',
    'Nueva cuenta': 'Nova conta',
    'Editar cuenta': 'Editar conta',
    'Crear cuenta': 'Criar conta',
    'Actualiza los datos de tu cuenta': 'Atualize os dados da sua conta',
    'Crea una cuenta para clasificar tus transacciones': 'Crie uma conta para classificar suas transações',
    'Saldo actual': 'Saldo atual',
    'Saldo de la tarjeta': 'Saldo do cartão',
    'Pagar tarjeta': 'Pagar cartão',
    'Registra el pago como transferencia hacia': 'Registre o pagamento como transferência para',
    'Cuenta origen': 'Conta origem',
    'Selecciona una cuenta': 'Selecione uma conta',
    'Monto a pagar': 'Valor a pagar',
    'Fecha de pago': 'Data de pagamento',
    'Pago de tarjeta': 'Pagamento de cartão',
    'Registrar pago': 'Registrar pagamento',
    'Registrando...': 'Registrando...',
    'No fue posible registrar el pago.': 'Não foi possível registrar o pagamento.',
    'Selecciona la cuenta desde donde saldrá el pago.': 'Selecione a conta de onde sairá o pagamento.',
    'Ingresa un valor mayor que cero.': 'Informe um valor maior que zero.',
    'Factura': 'Fatura',
    'Próximas cuotas': 'Próximas parcelas',
    'Sin cuenta': 'Sem conta',
    'Seleccionar cuenta': 'Selecionar conta',
    '+ Crear una cuenta': '+ Criar uma conta',
    '+ Añadir primera cuenta': '+ Adicionar primeira conta',
    'Metas': 'Metas',
    'Metas y deudas': 'Metas e dívidas',
    'Meta de ahorro': 'Meta de economia',
    'Fondo de emergencia': 'Reserva de emergência',
    'Deudas': 'Dívidas',
    'Deuda': 'Dívida',
    'Aportar': 'Aportar',
    'Pagar': 'Pagar',
    'Saldo actual:': 'Saldo atual:',
    'Saldo pendiente:': 'Saldo pendente:',
    'sin interés': 'sem juros',
    'Reportes': 'Relatórios',
    'Cash flow, categorías, recurrentes y exportación': 'Fluxo de caixa, categorias, recorrentes e exportação',
    'Exportar': 'Exportar',
    'Formato': 'Formato',
    'Recibos': 'Recibos',
    'Importar extracto bancario': 'Importar extrato bancário',
    'Banco / formato': 'Banco / formato',
    'Sube un extracto CSV u OFX y escoge el banco o país del archivo': 'Envie um extrato CSV ou OFX e escolha o banco ou país do arquivo',
    'Formatos: CSV / OFX exportados de Itaú (también funciona genérico)': 'Formatos: CSV / OFX exportados do banco selecionado (também funciona genérico)',
    'En CSV genérico usa columnas parecidas a: Data/Fecha/Date, Descrição/Descripción/Description/Concepto y Valor/Monto/Amount. Valores negativos = gastos, positivos = ingresos.': 'Em CSV genérico use colunas como: Data/Fecha/Date, Descrição/Descripción/Description/Concepto e Valor/Monto/Amount. Valores negativos = despesas, positivos = receitas.',
    'Ninguna': 'Nenhuma',
    'Configuración': 'Configurações',
    'Información de la Cuenta': 'Informações da Conta',
    'Tu información personal': 'Suas informações pessoais',
    'Email Verificado': 'Email Verificado',
    'Sí': 'Sim',
    'No': 'Não',
    'Cambiar Contraseña': 'Alterar Senha',
    'Contraseña Actual': 'Senha Atual',
    'Nueva Contraseña': 'Nova Senha',
    'Notificaciones': 'Notificações',
    'Recibe avisos por email, Telegram o WhatsApp cuando se acerque la fecha de pago': 'Receba avisos por email, Telegram ou WhatsApp quando a data de pagamento estiver próxima',
    'Notificaciones activadas': 'Notificações ativadas',
    'Si las desactivas, no se enviarán avisos automáticos': 'Se você desativar, os avisos automáticos não serão enviados',
    'Canales': 'Canais',
    'Avisar X días antes': 'Avisar X dias antes',
    'Email destino': 'Email de destino',
    'Si lo dejas vacío, se usa': 'Se deixar vazio, será usado',
    'Configurar Telegram': 'Configurar Telegram',
    'Configurar WhatsApp': 'Configurar WhatsApp',
    'activo': 'ativo',
    'expandir': 'expandir',
    'Bot Token': 'Token do bot',
    'Chat ID': 'Chat ID',
    '¿Cómo obtengo bot token y chat ID?': 'Como obtenho o token do bot e o chat ID?',
    'Número de WhatsApp': 'Número de WhatsApp',
    'Solo dígitos. Brasil:': 'Somente dígitos. Brasil:',
    'WhatsApp usa una conexión central configurada por el administrador del servidor.': 'O WhatsApp usa uma conexão central configurada pelo administrador do servidor.',
    'Envío automático diario a las': 'Envio automático diário às',
    'Próxima ejecución:': 'Próxima execução:',
    'Última ejecución:': 'Última execução:',
    'Guardar configuración': 'Salvar configurações',
    'Probar email': 'Testar email',
    'Probar Telegram': 'Testar Telegram',
    'Probar WhatsApp': 'Testar WhatsApp',
    'Notificar ahora': 'Notificar agora',
    'Configura el bot primero': 'Configure o bot primeiro',
    'Enviar prueba': 'Enviar teste',
    'Carga tu número primero': 'Informe seu número primeiro',
    'Enviar prueba por WhatsApp': 'Enviar teste por WhatsApp',
    'Activa notificaciones primero': 'Ative as notificações primeiro',
    'Idioma del sitio': 'Idioma do site',
    'Elige el idioma que quieres usar dentro del sistema': 'Escolha o idioma que quer usar dentro do sistema',
    'Idioma actual:': 'Idioma atual:',
    'Moneda preferida': 'Moeda preferida',
    'Moneda': 'Moeda',
    'Moneda en dashboard': 'Moeda no dashboard',
    'Idioma': 'Idioma',
    'Recuperar Contraseña': 'Recuperar Senha',
    'Ingresa tu email para recibir el código de recuperación': 'Digite seu email para receber o código de recuperação',
    'Enviar Código': 'Enviar Código',
    'Restablecer Contraseña': 'Redefinir Senha',
    'Código de Recuperación': 'Código de Recuperação',
    'Contraseña': 'Senha',
    'Confirmar Contraseña': 'Confirmar Senha',
    'Notas (opcional)': 'Notas (opcional)',
    'Etiquetas (separadas por coma)': 'Etiquetas (separadas por vírgula)',
    'Adjuntar recibo (imagen o PDF, ≤ 5 MB)': 'Anexar recibo (imagem ou PDF, até 5 MB)',
    'Leyendo recibo…': 'Lendo recibo...',
    'Pre-llenar desde foto del recibo': 'Pré-preencher pela foto do recibo',
    'Selecciona una fecha': 'Selecione uma data',
    'Recurrentes': 'Recorrentes',
    'Guardar recurrente': 'Salvar recorrente',
    'Próximos pagos (14 días)': 'Próximos pagamentos (14 dias)',
    'Internet residencial': 'Internet residencial',
    'Insights inteligentes': 'Insights inteligentes',
    'Aún no hay movimientos este mes': 'Ainda não há movimentações este mês',
    'Importa tu extracto o registra transacciones para comparar con el mes anterior.': 'Importe seu extrato ou registre transações para comparar com o mês anterior.',
    'Ingresos vs Gastos por mes': 'Receitas vs Despesas por mês',
    'Gastos por categoría': 'Despesas por categoria',
    'Patrimonio': 'Patrimônio',
    'Líquido': 'Líquido',
    'Crear primera meta': 'Criar primeira meta',
    '+ Crear primera meta': '+ Criar primeira meta',
    'Sin deudas registradas': 'Sem dívidas registradas',
    'Organiza tus ingresos y gastos en categorías y subcategorías': 'Organize suas receitas e despesas em categorias e subcategorias',
    'Define cuánto quieres gastar este mes por categoría. Te avisaremos cuando te acerques al límite y cuando lo excedas.': 'Defina quanto quer gastar este mês por categoria. Avisaremos quando você se aproximar do limite e quando o exceder.',
    'Crear primer presupuesto': 'Criar primeiro orçamento',
    'No budgets for': 'Sem orçamentos para',
    'Impuestos': 'Impostos',
    'Impuestos / Tasas': 'Impostos / Taxas',
    'Servicios': 'Serviços',
    'Educación': 'Educação',
    'Vivienda': 'Moradia',
    'Otros': 'Outros',
    'Entretenimiento': 'Entretenimento',
    'Salud': 'Saúde',
    'Alimentación': 'Alimentação',
    'Supermercado': 'Supermercado',
    'Transporte': 'Transporte',
    'Trabajo': 'Trabalho',
    'Sueldo': 'Salário',
    'Bonos / Comisiones': 'Bônus / Comissões',
    'Pensión / Jubilación': 'Pensão / Aposentadoria',
    'Préstamo recibido': 'Empréstimo recebido',
    'Rendimientos / Inversiones': 'Rendimentos / Investimentos',
    'Proventos': 'Proventos',
    'vs mes anterior': 'vs mês anterior',
    'acumulado total': 'acumulado total',
    'de tus gastos': 'das suas despesas',
    '¡Presupuesto excedido!': 'Orçamento excedido!',
    'Sistema': 'Sistema',
    'Inactiva': 'Inativa',
    'Subcategoría': 'Subcategoria',
    'Cargando…': 'Carregando...',
    'Cargando presupuestos…': 'Carregando orçamentos...',
    'Cargando recibos…': 'Carregando recibos...',
    'Cargando recibo…': 'Carregando recibo...',
    'Crear la primera': 'Criar a primeira',
    'Nueva categoría': 'Nova categoria',
    'Nueva subcategoría': 'Nova subcategoria',
    'Solo puedes editar el nombre y color': 'Você só pode editar o nome e a cor',
    'Define el nombre y tipo de la categoría': 'Defina o nome e o tipo da categoria',
    'Categoría padre (opcional)': 'Categoria pai (opcional)',
    'Recurrentes activos': 'Recorrentes ativos',
    'Total mensual estimado': 'Total mensal estimado',
    'solo gastos activos': 'apenas despesas ativas',
    'Generar este mes': 'Gerar este mês',
    'Manual': 'Manual',
    'Plantillas rápidas': 'Modelos rápidos',
    'Un clic para precargar el formulario con los datos típicos. Solo te queda poner el monto.': 'Um clique preenche o formulário com os dados típicos. Só falta informar o valor.',
    'Tus recurrentes': 'Seus recorrentes',
    'Sin recurrentes': 'Sem recorrentes',
    'Sin recurrentes activos': 'Sem recorrentes ativos',
    'Alquiler, internet, suscripciones y otras facturas mensuales': 'Aluguel, internet, assinaturas e outras contas mensais',
    'Alquiler': 'Aluguel',
    'Alquiler mensual': 'Aluguel mensal',
    'Teléfono / Plan': 'Telefone / Plano',
    'Plan móvil': 'Plano móvel',
    'Seguro': 'Seguro',
    'Seguro mensual': 'Seguro mensal',
    'Luz / Agua / Gas': 'Luz / Água / Gás',
    'Servicios públicos': 'Serviços públicos',
    'Gimnasio': 'Academia',
    'Mensualidad gym': 'Mensalidade da academia',
    'Suscripción': 'Assinatura',
    'Otra suscripción': 'Outra assinatura',
    'Donación': 'Doação',
    'Donación mensual': 'Doação mensal',
    'Coche': 'Carro',
    'Cuota / seguro vehículo': 'Parcela / seguro do veículo',
    'Todo al día — no había recurrentes pendientes': 'Tudo em dia — não havia recorrentes pendentes',
    'Se generará automáticamente cada mes al pulsar "Generar este mes".': 'Será gerado automaticamente todo mês ao clicar em "Gerar este mês".',
    'Ingresos vs mes anterior': 'Receitas vs mês anterior',
    'Gastos vs mes anterior': 'Despesas vs mês anterior',
    'día': 'dia',
    'pago día': 'pagamento dia',
    'Cartão': 'Cartão',
    'Tarjeta': 'Cartão',
    'tarjeta': 'cartão',
    'padre': 'pai',
    'Define un límite mensual por categoría y mira cómo lo estás cumpliendo.': 'Defina um limite mensal por categoria e veja como você está acompanhando.',
    'excedidos / cerca del límite': 'excedidos / perto do limite',
    'Cerca del límite': 'Perto do limite',
    'Crea categorías de gasto en': 'Crie categorias de despesa em',
    'Todas tus categorías ya tienen presupuesto este mes.': 'Todas as suas categorias já têm orçamento este mês.',
    'Límite mensual': 'Limite mensal',
    'Meta': 'Meta',
    'Aún no tienes metas': 'Você ainda não tem metas',
    'Nueva meta': 'Nova meta',
    'Nueva deuda': 'Nova dívida',
    'Registrar primera deuda': 'Registrar primeira dívida',
    'Registra préstamos, financiamientos o saldos pendientes para hacer seguimiento.': 'Registre empréstimos, financiamentos ou saldos pendentes para acompanhar.',
    'Crea una meta de ahorro o tu fondo de emergencia': 'Crie uma meta de poupança ou seu fundo de emergência',
    'Fecha límite (opcional)': 'Data limite (opcional)',
    'Crear meta': 'Criar meta',
    'Registra una deuda, préstamo o financiamiento': 'Registre uma dívida, empréstimo ou financiamento',
    '% interés anual': '% juros anuais',
    'Día de pago': 'Dia de pagamento',
    'Crear deuda': 'Criar dívida',
    'deuda(s)': 'dívida(s)',
    'anual': 'anual',
    'Total ahorrado': 'Total economizado',
    'Define tu primer objetivo de ahorro o tu fondo de emergencia.': 'Defina seu primeiro objetivo de economia ou seu fundo de emergência.',
    'Deuda total': 'Dívida total',
    'No configurado': 'Não configurado',
    'Fondo de emergencia': 'Fundo de emergência',
    'Emergency fund': 'Fundo de emergência',
    'Distribución': 'Distribuição',
    'Top categorías': 'Top categorias',
    'Sin gastos en este periodo': 'Sem despesas neste período',
    'Mayor categoría': 'Maior categoria',
    'Por categoría': 'Por categoria',
    'Progreso por meta': 'Progresso por meta',
    'Aún no tienes metas creadas.': 'Você ainda não tem metas criadas.',
    'Exportar todo': 'Exportar tudo',
    'Periodo:': 'Período:',
    'Periodo': 'Período',
    'Objetivo total': 'Objetivo total',
    'Progreso global': 'Progresso global',
    'Estimado anual': 'Estimativa anual',
    'Mes actual': 'Mês atual',
    'Mes anterior': 'Mês anterior',
    'Año actual (YTD)': 'Ano atual (YTD)',
    'Últimos 3 meses': 'Últimos 3 meses',
    'Últimos 6 meses': 'Últimos 6 meses',
    'Últimos 12 meses': 'Últimos 12 meses',
    'sin datos': 'sem dados',
    'Galería de recibos': 'Galeria de recibos',
    'Todos los comprobantes adjuntos a tus transacciones': 'Todos os comprovantes anexados às suas transações',
    'Filtros:': 'Filtros:',
    'Todas las categorías': 'Todas as categorias',
    'Todos los meses': 'Todos os meses',
    'Limpiar filtros': 'Limpar filtros',
    'recibo(s)': 'recibo(s)',
    'Total:': 'Total:',
    'en gastos': 'em despesas',
    'Sin recibos para estos filtros': 'Sem recibos para estes filtros',
    'Aún no tienes recibos': 'Você ainda não tem recibos',
    'Prueba a ajustar los filtros o limpiar la selección.': 'Tente ajustar os filtros ou limpar a seleção.',
    'Adjunta recibos a tus transacciones desde el dashboard o el editor de transacciones — aparecerán aquí automáticamente.': 'Anexe recibos às suas transações pelo dashboard ou editor de transações — eles aparecerão aqui automaticamente.',
    'Detalle del recibo': 'Detalhe do recibo',
    'No se pudo cargar el recibo.': 'Não foi possível carregar o recibo.',
    'Importación completada': 'Importação concluída',
    'Categoría por defecto': 'Categoria padrão',
    'Procesando…': 'Processando...',
    'Arrastra tu archivo aquí o haz clic': 'Arraste seu arquivo aqui ou clique',
    'Formatos: CSV / OFX exportados por banco o CSV genérico con fecha, descripción y valor': 'Formatos: CSV / OFX exportados pelo banco ou CSV genérico com data, descrição e valor',
    '¿Dónde consigo el archivo?': 'Onde consigo o arquivo?',
    'Accede a tu banca web o app del banco.': 'Acesse o internet banking ou app do banco.',
    'Ve a': 'Vá para',
    'y elige el periodo.': 'e escolha o período.',
    'Descarga el extracto como': 'Baixe o extrato como',
    'u': 'ou',
    'Selecciona el banco/formato y sube el archivo aquí. Verás un preview antes de guardar.': 'Selecione o banco/formato e envie o arquivo aqui. Você verá uma prévia antes de salvar.',
    'Cuenta destino (opcional)': 'Conta destino (opcional)',
    'Cuenta destino': 'Conta destino',
    'Cuenta origen': 'Conta origem',
    'Cuenta origen (opcional)': 'Conta origem (opcional)',
    'periodo': 'período',
    'Descarga el extracto como': 'Baixe o extrato como',
    'Selecciona el banco/formato y sube el archivo aquí. Verás un preview antes de guardar.': 'Selecione o banco/formato e envie o arquivo aqui. Você verá uma prévia antes de salvar.',
    'Incluir esta transacción': 'Incluir esta transação',
    'Selecciona al menos una transacción.': 'Selecione pelo menos uma transação.',
    'Para importar transferencias selecciona cuenta origen y cuenta destino diferente.': 'Para importar transferências, selecione conta origem e conta destino diferentes.',
    'Error al guardar': 'Erro ao salvar',
    'Gestiona tu cuenta y preferencias': 'Gerencie sua conta e preferências',
    'Elige la moneda en que se mostrarán todos tus montos': 'Escolha a moeda em que todos os seus valores serão exibidos',
    'Actualiza tu contraseña de acceso': 'Atualize sua senha de acesso',
    'Confirmar Nueva Contraseña': 'Confirmar Nova Senha',
    'Configuración guardada': 'Configuração salva',
    'No se pudo guardar la configuración': 'Não foi possível salvar a configuração',
    'Las contraseñas no coinciden': 'As senhas não coincidem',
    'La contraseña debe tener al menos 6 caracteres': 'A senha deve ter pelo menos 6 caracteres',
    'Contraseña actualizada correctamente': 'Senha atualizada corretamente',
    'Error al cambiar la contraseña': 'Erro ao alterar a senha',
    'Se procesaron': 'Foram processados',
    'pagos próximos': 'pagamentos próximos',
    'ya configurado, deja vacío para mantener': 'já configurado, deixe vazio para manter',
    'con código de país, sin +': 'com código do país, sem +',
    'Si el botón "Probar WhatsApp" devuelve un error de "no configurado", avísale al': 'Se o botão "Testar WhatsApp" retornar erro de "não configurado", avise o',
    'usuario(s)': 'usuário(s)',
    'aviso(s)': 'aviso(s)',
    'Para guardar como transferencia selecciona cuenta origen y cuenta destino.': 'Para salvar como transferência, selecione conta origem e conta destino.',
    'La cuenta origen y la cuenta destino deben ser diferentes.': 'A conta origem e a conta destino devem ser diferentes.',
    'Para convertir en transferencia selecciona una cuenta origen y una cuenta destino diferente.': 'Para converter em transferência, selecione uma conta origem e uma conta destino diferente.',
    'No se pudo guardar la transacción. Revisa los datos e intenta nuevamente.': 'Não foi possível salvar a transação. Revise os dados e tente novamente.',
    'Reiniciar datos financieros': 'Reiniciar dados financeiros',
    'Esta acción borra cuentas, transacciones, presupuestos, metas, deudas, recurrentes, recibos y registros financieros del usuario. La cuenta de acceso se conserva.': 'Esta ação apaga contas, transações, orçamentos, metas, dívidas, recorrentes, recibos e registros financeiros do usuário. A conta de acesso é preservada.',
    'Escribe RESET': 'Digite RESET',
    'Reiniciar': 'Reiniciar',
    'Datos financieros reiniciados para': 'Dados financeiros reiniciados para',
    'Transacciones eliminadas:': 'Transações eliminadas:',
    'No fue posible reiniciar los datos financieros': 'Não foi possível reiniciar os dados financeiros',
  },
};

const sourceByTranslation = Object.fromEntries(
  Object.entries(textMap).map(([lang, map]) => [
    lang,
    Object.fromEntries(Object.entries(map).map(([source, target]) => [target, source])),
  ])
);

const monthMap = {
  en: {
    Enero: 'January',
    Janeiro: 'January',
    Febrero: 'February',
    Fevereiro: 'February',
    Marzo: 'March',
    Março: 'March',
    Abril: 'April',
    Mayo: 'May',
    Maio: 'May',
    Junio: 'June',
    Junho: 'June',
    Julio: 'July',
    Julho: 'July',
    Agosto: 'August',
    Septiembre: 'September',
    Setembro: 'September',
    Octubre: 'October',
    Outubro: 'October',
    Noviembre: 'November',
    Novembro: 'November',
    Diciembre: 'December',
    Dezembro: 'December',
  },
  pt: {
    Enero: 'Janeiro',
    January: 'Janeiro',
    Febrero: 'Fevereiro',
    February: 'Fevereiro',
    Marzo: 'Março',
    March: 'Março',
    Abril: 'Abril',
    April: 'Abril',
    Mayo: 'Maio',
    May: 'Maio',
    Junio: 'Junho',
    June: 'Junho',
    Julio: 'Julho',
    July: 'Julho',
    Agosto: 'Agosto',
    August: 'Agosto',
    Septiembre: 'Setembro',
    September: 'Setembro',
    Octubre: 'Outubro',
    October: 'Outubro',
    Noviembre: 'Novembro',
    November: 'Novembro',
    Diciembre: 'Dezembro',
    December: 'Dezembro',
  },
  es: {
    Janeiro: 'Enero',
    January: 'Enero',
    Fevereiro: 'Febrero',
    February: 'Febrero',
    Março: 'Marzo',
    March: 'Marzo',
    Abril: 'Abril',
    April: 'Abril',
    Maio: 'Mayo',
    May: 'Mayo',
    Junho: 'Junio',
    June: 'Junio',
    Julho: 'Julio',
    July: 'Julio',
    Agosto: 'Agosto',
    August: 'Agosto',
    Setembro: 'Septiembre',
    September: 'Septiembre',
    Outubro: 'Octubre',
    October: 'Octubre',
    Novembro: 'Noviembre',
    November: 'Noviembre',
    Dezembro: 'Diciembre',
    December: 'Diciembre',
  },
};

const dynamicTerms = {
  en: {
    Ingresos: 'Income',
    Receitas: 'Income',
    Gastos: 'Expenses',
    Despesas: 'Expenses',
    Inversiones: 'Investments',
    Investimentos: 'Investments',
    Patrimonio: 'Net worth',
    Patrimônio: 'Net worth',
    Líquido: 'Liquid',
    cuenta: 'account',
    cuentas: 'accounts',
    conta: 'account',
    contas: 'accounts',
    padre: 'parent',
    pai: 'parent',
    día: 'day',
    dia: 'day',
    mês: 'month',
    mes: 'month',
    este: 'this',
    'este mes': 'this month',
    'mes anterior': 'previous month',
    'mês anterior': 'previous month',
    'de tus gastos': 'of your expenses',
    'das suas despesas': 'of your expenses',
    'pago día': 'payment day',
    anterior: 'previous',
    total: 'total',
    límite: 'limit',
    Límite: 'Limit',
    presupuesto: 'budget',
    presupuestos: 'budgets',
    deuda: 'debt',
    deudas: 'debts',
    recibo: 'receipt',
    recibos: 'receipts',
    extracto: 'statement',
    extractos: 'statements',
    gasto: 'expense',
    gastos: 'expenses',
    ingreso: 'income',
    ingresos: 'income',
    categoría: 'category',
    categorías: 'categories',
    actual: 'current',
    anterior: 'previous',
    período: 'period',
    periodo: 'period',
    selección: 'selection',
    Selección: 'Selection',
    configuración: 'settings',
    Configuración: 'Settings',
    contraseña: 'password',
    Contraseña: 'Password',
    prueba: 'test',
    Prueba: 'Test',
    próximos: 'upcoming',
    Próximos: 'Upcoming',
    mensual: 'monthly',
    Mensual: 'Monthly',
    activos: 'active',
    ativos: 'active',
    activo: 'active',
    ativo: 'active',
    solo: 'only',
    apenas: 'only',
    Sistema: 'System',
    Inactiva: 'Inactive',
    Inativa: 'Inactive',
    Subcategoría: 'Subcategory',
    Subcategoria: 'Subcategory',
    Manual: 'Manual',
    Cartão: 'Card',
    cartão: 'card',
    Categorías: 'Categories',
    Categorias: 'Categories',
    Categoría: 'Category',
    Categoria: 'Category',
    Impuestos: 'Taxes',
    Serviços: 'Services',
    Servicios: 'Services',
    Educação: 'Education',
    Educación: 'Education',
    Moradia: 'Housing',
    Vivienda: 'Housing',
    Outros: 'Other',
    Otros: 'Other',
    Entretenimento: 'Entertainment',
    Entretenimiento: 'Entertainment',
    Saúde: 'Health',
    Salud: 'Health',
    Alimentación: 'Food',
    Alimentação: 'Food',
    Supermercado: 'Groceries',
    Transporte: 'Transportation',
    Trabajo: 'Work',
    Trabalho: 'Work',
    Sueldo: 'Salary',
    Salário: 'Salary',
    Proventos: 'Investment proceeds',
    Ahorraste: 'You saved',
    'Podrías ahorrar': 'You could save',
    Podrías: 'You could',
    mayor: 'largest',
    'Tu mayor': 'Your largest',
    Redujiste: 'You reduced',
    'Buen trabajo': 'Good job',
    ahorrado: 'saved',
    Ahorrado: 'Saved',
    objetivo: 'target',
    Objetivo: 'Target',
    global: 'overall',
    Global: 'Overall',
    estimado: 'estimate',
    Estimado: 'Estimate',
    anual: 'annual',
    Anual: 'Annual',
    configurado: 'configured',
    Configurado: 'Configured',
    recurrente: 'recurring',
    recurrentes: 'recurring',
    Alquiler: 'Rent',
    'Teléfono / Plan': 'Phone / Plan',
    Seguro: 'Insurance',
    'Luz / Agua / Gas': 'Electricity / Water / Gas',
    Gimnasio: 'Gym',
    Suscripción: 'Subscription',
    Donación: 'Donation',
    Coche: 'Car',
  },
  pt: {
    Ingresos: 'Receitas',
    Income: 'Receitas',
    Gastos: 'Despesas',
    Expenses: 'Despesas',
    Inversiones: 'Investimentos',
    Investments: 'Investimentos',
    Patrimonio: 'Patrimônio',
    'Net worth': 'Patrimônio',
    cuenta: 'conta',
    cuentas: 'contas',
    account: 'conta',
    accounts: 'contas',
    padre: 'pai',
    parent: 'pai',
    día: 'dia',
    day: 'dia',
    month: 'mês',
    this: 'este',
    'this month': 'este mês',
    este: 'este',
    'este mes': 'este mês',
    'mes anterior': 'mês anterior',
    'previous month': 'mês anterior',
    'de tus gastos': 'das suas despesas',
    'of your expenses': 'das suas despesas',
    'pago día': 'pagamento dia',
    'payment day': 'pagamento dia',
    previous: 'anterior',
    active: 'ativo',
    only: 'apenas',
    limit: 'limite',
    Limit: 'Limite',
    budget: 'orçamento',
    budgets: 'orçamentos',
    debt: 'dívida',
    debts: 'dívidas',
    receipt: 'recibo',
    receipts: 'recibos',
    statement: 'extrato',
    statements: 'extratos',
    expense: 'despesa',
    expenses: 'despesas',
    income: 'receita',
    current: 'atual',
    period: 'período',
    selection: 'seleção',
    Selection: 'Seleção',
    settings: 'configurações',
    Settings: 'Configurações',
    password: 'senha',
    Password: 'Senha',
    test: 'teste',
    Test: 'Teste',
    upcoming: 'próximos',
    Upcoming: 'Próximos',
    monthly: 'mensal',
    Monthly: 'Mensal',
    System: 'Sistema',
    Inactiva: 'Inativa',
    Inactive: 'Inativo',
    Subcategoría: 'Subcategoria',
    Subcategory: 'Subcategoria',
    Manual: 'Manual',
    Card: 'Cartão',
    card: 'cartão',
    Tarjeta: 'Cartão',
    tarjeta: 'cartão',
    Categorías: 'Categorias',
    Categories: 'Categorias',
    Categoría: 'Categoria',
    Category: 'Categoria',
    Impuestos: 'Impostos',
    Taxes: 'Impostos',
    Servicios: 'Serviços',
    Services: 'Serviços',
    Educación: 'Educação',
    Education: 'Educação',
    Vivienda: 'Moradia',
    Housing: 'Moradia',
    Otros: 'Outros',
    Other: 'Outros',
    Entretenimiento: 'Entretenimento',
    Entertainment: 'Entretenimento',
    Salud: 'Saúde',
    Health: 'Saúde',
    Alimentación: 'Alimentação',
    Food: 'Alimentação',
    Groceries: 'Supermercado',
    Transporte: 'Transporte',
    Transportation: 'Transporte',
    Trabajo: 'Trabalho',
    Work: 'Trabalho',
    Sueldo: 'Salário',
    Salary: 'Salário',
    Proventos: 'Proventos',
    Ahorraste: 'Você economizou',
    'You saved': 'Você economizou',
    'Podrías ahorrar': 'Você poderia economizar',
    'You could save': 'Você poderia economizar',
    Podrías: 'Você poderia',
    'You could': 'Você poderia',
    mayor: 'maior',
    largest: 'maior',
    'Tu mayor': 'Sua maior',
    'Your largest': 'Sua maior',
    Redujiste: 'Você reduziu',
    'You reduced': 'Você reduziu',
    'Buen trabajo': 'Bom trabalho',
    'Good job': 'Bom trabalho',
    ahorrado: 'economizado',
    saved: 'economizado',
    Saved: 'Economizado',
    objetivo: 'objetivo',
    target: 'objetivo',
    Target: 'Objetivo',
    global: 'global',
    overall: 'global',
    Overall: 'Global',
    estimado: 'estimativa',
    estimate: 'estimativa',
    Estimate: 'Estimativa',
    annual: 'anual',
    Annual: 'Anual',
    configurado: 'configurado',
    configured: 'configurado',
    Configured: 'Configurado',
    recurrente: 'recorrente',
    recurrentes: 'recorrentes',
    recurring: 'recorrente',
    Alquiler: 'Aluguel',
    Rent: 'Aluguel',
    'Teléfono / Plan': 'Telefone / Plano',
    'Phone / Plan': 'Telefone / Plano',
    Seguro: 'Seguro',
    Insurance: 'Seguro',
    'Luz / Agua / Gas': 'Luz / Água / Gás',
    'Electricity / Water / Gas': 'Luz / Água / Gás',
    Gimnasio: 'Academia',
    Gym: 'Academia',
    Suscripción: 'Assinatura',
    Subscription: 'Assinatura',
    Donación: 'Doação',
    Donation: 'Doação',
    Coche: 'Carro',
    Car: 'Carro',
  },
  es: {
    Receitas: 'Ingresos',
    Income: 'Ingresos',
    Despesas: 'Gastos',
    Expenses: 'Gastos',
    Investimentos: 'Inversiones',
    Investments: 'Inversiones',
    Patrimônio: 'Patrimonio',
    'Net worth': 'Patrimonio',
    conta: 'cuenta',
    contas: 'cuentas',
    account: 'cuenta',
    accounts: 'cuentas',
    pai: 'padre',
    parent: 'padre',
    dia: 'día',
    day: 'día',
    mês: 'mes',
    month: 'mes',
    this: 'este',
    'this month': 'este mes',
    'mês anterior': 'mes anterior',
    'previous month': 'mes anterior',
    'das suas despesas': 'de tus gastos',
    'of your expenses': 'de tus gastos',
    'pagamento dia': 'pago día',
    'payment day': 'pago día',
    previous: 'anterior',
    active: 'activo',
    only: 'solo',
    limit: 'límite',
    Limit: 'Límite',
    budget: 'presupuesto',
    budgets: 'presupuestos',
    debt: 'deuda',
    debts: 'deudas',
    receipt: 'recibo',
    receipts: 'recibos',
    statement: 'extracto',
    statements: 'extractos',
    expense: 'gasto',
    expenses: 'gastos',
    income: 'ingreso',
    current: 'actual',
    period: 'período',
    selection: 'selección',
    Selection: 'Selección',
    settings: 'configuración',
    Settings: 'Configuración',
    password: 'contraseña',
    Password: 'Contraseña',
    test: 'prueba',
    Test: 'Prueba',
    upcoming: 'próximos',
    Upcoming: 'Próximos',
    monthly: 'mensual',
    Monthly: 'Mensual',
    System: 'Sistema',
    Inativa: 'Inactiva',
    Inactive: 'Inactiva',
    Subcategoria: 'Subcategoría',
    Subcategory: 'Subcategoría',
    Manual: 'Manual',
    Cartão: 'Tarjeta',
    Card: 'Tarjeta',
    card: 'tarjeta',
    Categorias: 'Categorías',
    Categories: 'Categorías',
    Categoria: 'Categoría',
    Category: 'Categoría',
    Impostos: 'Impuestos',
    Taxes: 'Impuestos',
    Serviços: 'Servicios',
    Services: 'Servicios',
    Educação: 'Educación',
    Education: 'Educación',
    Moradia: 'Vivienda',
    Housing: 'Vivienda',
    Outros: 'Otros',
    Other: 'Otros',
    Entretenimento: 'Entretenimiento',
    Entertainment: 'Entretenimiento',
    Saúde: 'Salud',
    Health: 'Salud',
    Alimentação: 'Alimentación',
    Food: 'Alimentación',
    Groceries: 'Supermercado',
    Transporte: 'Transporte',
    Transportation: 'Transporte',
    Trabalho: 'Trabajo',
    Work: 'Trabajo',
    Salário: 'Sueldo',
    Salary: 'Sueldo',
    'Investment proceeds': 'Proventos',
    'You saved': 'Ahorraste',
    'You could save': 'Podrías ahorrar',
    'You could': 'Podrías',
    largest: 'mayor',
    'Your largest': 'Tu mayor',
    'You reduced': 'Redujiste',
    'Good job': 'Buen trabajo',
    saved: 'ahorrado',
    Saved: 'Ahorrado',
    target: 'objetivo',
    Target: 'Objetivo',
    overall: 'global',
    Overall: 'Global',
    estimate: 'estimado',
    Estimate: 'Estimado',
    annual: 'anual',
    Annual: 'Anual',
    configured: 'configurado',
    Configured: 'Configurado',
    recurring: 'recurrente',
    Rent: 'Alquiler',
    'Phone / Plan': 'Teléfono / Plan',
    Insurance: 'Seguro',
    'Electricity / Water / Gas': 'Luz / Agua / Gas',
    Gym: 'Gimnasio',
    Subscription: 'Suscripción',
    Donation: 'Donación',
    Car: 'Coche',
  },
};

const textSources = new WeakMap();
const attrSources = new WeakMap();
const translatedAttrs = ['placeholder', 'aria-label', 'title'];

function translateMonths(value, language) {
  const map = monthMap[language] || {};
  return Object.entries(map).reduce(
    (text, [source, target]) => text.replace(new RegExp(`\\b${source}\\b`, 'g'), target),
    value
  );
}

function translateKnownTerms(value, language) {
  const map = dynamicTerms[language] || {};
  return Object.entries(map)
    .sort((a, b) => b[0].length - a[0].length)
    .reduce((text, [source, target]) => text.replace(new RegExp(`\\b${source}\\b`, 'g'), target), value);
}

function translateCategoryName(value, language) {
  const directSource = sourceByTranslation.en[value] || sourceByTranslation.pt[value] || value;
  return textMap[language]?.[directSource] || translateKnownTerms(directSource, language);
}

function formatDaysUntil(category, days, language) {
  const translatedCategory = translateCategoryName(category, language);
  const count = Number(days);
  if (language === 'en') return `${translatedCategory} · in ${count} ${count === 1 ? 'day' : 'days'}`;
  if (language === 'pt') return `${translatedCategory} · em ${count} ${count === 1 ? 'dia' : 'dias'}`;
  return `${translatedCategory} · en ${count} ${count === 1 ? 'día' : 'días'}`;
}

function translateDynamicText(value, language) {
  let text = translateMonths(value, language);

  const savedThisMonthMatch = text.match(/^¡?(?:Ahorraste|You saved|Você economizou) ([\d.,]+)% (?:este mes|this month|este mês)!?$/i);
  if (savedThisMonthMatch) {
    if (language === 'en') return `You saved ${savedThisMonthMatch[1]}% this month!`;
    if (language === 'pt') return `Você economizou ${savedThisMonthMatch[1]}% este mês!`;
    return `¡Ahorraste ${savedThisMonthMatch[1]}% este mes!`;
  }

  const largestExpenseMatch = text.match(/^(?:Tu mayor gasto es|Your largest expense is|Sua maior despesa é) (.+)$/i);
  if (largestExpenseMatch) {
    const category = translateCategoryName(largestExpenseMatch[1], language);
    if (language === 'en') return `Your largest expense is ${category}`;
    if (language === 'pt') return `Sua maior despesa é ${category}`;
    return `Tu mayor gasto es ${category}`;
  }

  const reducedCategoryMatch = text.match(/^(?:Redujiste|You reduced|Você reduziu) (.+?) (?:en|by|em) ([\d.,]+)%$/i);
  if (reducedCategoryMatch) {
    const category = translateCategoryName(reducedCategoryMatch[1], language);
    if (language === 'en') return `You reduced ${category} by ${reducedCategoryMatch[2]}%`;
    if (language === 'pt') return `Você reduziu ${category} em ${reducedCategoryMatch[2]}%`;
    return `Redujiste ${category} en ${reducedCategoryMatch[2]}%`;
  }

  const goodJobSavedMatch = text.match(/^¡?(?:Buen trabajo|Good job|Bom trabalho)!? (?:Ahorraste|You saved|Você economizou) (.+?)(?:\s*)\(([\d.,]+)%\)$/i);
  if (goodJobSavedMatch) {
    if (language === 'en') return `Good job! You saved ${goodJobSavedMatch[1]} (${goodJobSavedMatch[2]}%)`;
    if (language === 'pt') return `Bom trabalho! Você economizou ${goodJobSavedMatch[1]} (${goodJobSavedMatch[2]}%)`;
    return `¡Buen trabajo! Ahorraste ${goodJobSavedMatch[1]} (${goodJobSavedMatch[2]}%)`;
  }

  const couldSaveMatch = text.match(/^(?:Podrías ahorrar|You could save|Você poderia economizar) (.+?) (?:en|on|em) (?:recurrentes|recurring|recorrentes?) (.+)$/i);
  if (couldSaveMatch) {
    const label = translateCategoryName(couldSaveMatch[2], language);
    if (language === 'en') return `You could save ${couldSaveMatch[1]} on recurring ${label}`;
    if (language === 'pt') return `Você poderia economizar ${couldSaveMatch[1]} em recorrentes ${label}`;
    return `Podrías ahorrar ${couldSaveMatch[1]} en recurrentes ${label}`;
  }

  const daysMatch = text.match(/^(.+?) · (?:en|em|in) (\d+) (?:día|días|dia|dias|day|days)$/i);
  if (daysMatch) return formatDaysUntil(daysMatch[1], daysMatch[2], language);

  const netWorthMatch = text.match(/^(?:Patrimonio|Patrimônio|Net worth) · (\d+) (?:cuenta|cuentas|conta|contas|account|accounts)\(s\)$/i);
  if (netWorthMatch) {
    const count = Number(netWorthMatch[1]);
    if (language === 'en') return `Net worth · ${count} ${count === 1 ? 'account' : 'accounts'}`;
    if (language === 'pt') return `Patrimônio · ${count} ${count === 1 ? 'conta' : 'contas'}`;
    return `Patrimonio · ${count} ${count === 1 ? 'cuenta' : 'cuentas'}`;
  }

  const budgetsMatch = text.match(/^(?:Sin presupuestos para|Sem orçamentos para|No budgets for) (.+)$/i);
  if (budgetsMatch) {
    const month = translateMonths(budgetsMatch[1], language);
    if (language === 'en') return `No budgets for ${month}`;
    if (language === 'pt') return `Sem orçamentos para ${month}`;
    return `Sin presupuestos para ${month}`;
  }

  text = translateKnownTerms(text, language);
  return text;
}

function translateExact(value, language) {
  const trimmed = value.trim();
  if (!trimmed) return value;
  const source = sourceByTranslation.en[trimmed] || sourceByTranslation.pt[trimmed] || trimmed;
  const translated = language === 'es' ? translateDynamicText(source, language) : (textMap[language]?.[source] || translateDynamicText(source, language));
  if (!translated) return value;
  return value.replace(trimmed, translated);
}

function translateNodeText(node, language) {
  const raw = node.nodeValue || '';
  const trimmed = raw.trim();
  if (!trimmed) return;
  const currentSource = textSources.get(node) || sourceByTranslation.en[trimmed] || sourceByTranslation.pt[trimmed] || trimmed;
  textSources.set(node, currentSource);
  if (language === 'es') {
    const next = raw.replace(trimmed, translateDynamicText(currentSource, language));
    if (next !== raw) node.nodeValue = next;
    return;
  }
  const translated = textMap[language]?.[currentSource] || translateDynamicText(currentSource, language);
  if (translated) {
    const next = raw.replace(trimmed, translated);
    if (next !== raw) node.nodeValue = next;
  }
}

function translateElementAttrs(element, language) {
  for (const attr of translatedAttrs) {
    const value = element.getAttribute(attr);
    if (!value) continue;
    let sourceMap = attrSources.get(element);
    if (!sourceMap) {
      sourceMap = {};
      attrSources.set(element, sourceMap);
    }
    const source = sourceMap[attr] || sourceByTranslation.en[value] || sourceByTranslation.pt[value] || value;
    sourceMap[attr] = source;
    const next = language === 'es' ? source : translateExact(source, language);
    if (next !== value) element.setAttribute(attr, next);
  }
}

function translateTree(root, language) {
  if (!root) return;
  const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
  const textNodes = [];
  while (walker.nextNode()) textNodes.push(walker.currentNode);
  textNodes.forEach((node) => translateNodeText(node, language));

  if (root.nodeType === Node.ELEMENT_NODE) translateElementAttrs(root, language);
  root.querySelectorAll?.('*').forEach((element) => translateElementAttrs(element, language));
}

export function useDomTranslations(language) {
  useEffect(() => {
    const run = () => translateTree(document.body, language);
    const schedule = () => window.setTimeout(run, 120);
    const timers = [0, 250, 800, 1600, 3000].map((delay) => window.setTimeout(run, delay));
    window.addEventListener('click', schedule, true);
    window.addEventListener('change', schedule, true);
    window.addEventListener('keyup', schedule, true);
    window.addEventListener('popstate', schedule);
    return () => {
      timers.forEach((timer) => window.clearTimeout(timer));
      window.removeEventListener('click', schedule, true);
      window.removeEventListener('change', schedule, true);
      window.removeEventListener('keyup', schedule, true);
      window.removeEventListener('popstate', schedule);
    };
  }, [language]);
}
